export default "__VITE_ASSET__CvGOEiTX__"